import { connect } from "react-redux";

import { getAccountChanges } from "actions/account_changes";
import AccountChanges from "./AccountChanges";


const mapState = ({ account_changes }) => ({
    data: account_changes.list,
    loading: account_changes.loading,
});

export default connect(mapState, {
    getAccountChanges
})(AccountChanges);